module.exports = __webpack_public_path__ + "static/img/theme.a8c15249.svg";